var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-snackbar',{attrs:{"bottom":true,"color":_vm.snackbar.color,"right":true,"multi-line":true,"timeout":_vm.timeout,"vertical":false},model:{value:(_vm.snackbar.snackbar),callback:function ($$v) {_vm.$set(_vm.snackbar, "snackbar", $$v)},expression:"snackbar.snackbar"}},[_vm._v(" "+_vm._s(_vm.textFinal)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }